// extracted by mini-css-extract-plugin
module.exports = {"container":"topTournamentLogo__container___AxZPS","icon":"topTournamentLogo__icon___2iDWu","logo":"topTournamentLogo__logo___2AMeh"};